export const actions = {
  SET_TRACKS_DATA: "SET_TRACKS_DATA",
  TOGGLE_PLAY: "TOGGLE_PLAY",
  HANDLE_PREV_SONG: "HANDLE_PREV_SONG",
  HANDLE_NEXT_SONG: "HANDLE_NEXT_SONG",
  TOGGLE_SAVE_TRACK: "TOGGLE_SAVE_TRACK",
};
